import { isType } from "forms/helpers/checkJsonSchemaType";
import type { IProperty } from "types/jsonSchema";

export default function parseNull(field: IProperty, schema: unknown, isRequired: boolean) {
    if (isType(field.type, "null") || !isRequired) {
        // @ts-expect-error too many zod types to handle
        return schema.nullable().default(null);
    }

    return schema;
}
